import { Button } from "@omni/ui/components/Button/button.component";
import { ComponentType, useEffect } from "react";
import { useSelector } from "react-redux";

import { Flyout } from "@/components/General/Flyout/flyout";
import { AvailableInStore } from "@/components/Search/SearchResults/components/AvailableInStore/availableInStore.component";
import { getQuery } from "@/redux/modules/value/search/search.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export type MobileFacetsProps = {
    isOpen: boolean;
    onClose: () => void;
    className?: string;
};

type MobileFacetsComponent = { FacetsComponent: ComponentType<unknown> };

const MobileFacets = ({
    isOpen,
    onClose,
    className,
    FacetsComponent
}: MobileFacetsProps & MobileFacetsComponent) => {
    const { t } = useGranite();

    const query = useSelector(getQuery);

    const close = () => {
        if (!isOpen) return;
        onClose();
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        close();
    }, [query]);

    return (
        <Flyout
            open={isOpen}
            className={className}
            onClose={close}
        >
            <Flyout.Content>
                <AvailableInStore />
                <FacetsComponent />
            </Flyout.Content>
            <Flyout.Controls>
                <Button
                    type={"button"}
                    color={"link"}
                    className={"cursor-pointer"}
                    onClick={close}
                >
                    {t("search.refinements.mobile.close")}
                </Button>
                <Flyout.Controls.CloseButton>
                    {t("search.refinements.mobile.apply")}
                </Flyout.Controls.CloseButton>
            </Flyout.Controls>
        </Flyout>
    );
};

export { MobileFacets };
